function createExtraScopePlugin() {
  for (var _len = arguments.length, extra = new Array(_len), _key = 0; _key < _len; _key++) {
    extra[_key] = arguments[_key];
  }

  var scopes = extra.map(function (scope) {
    return scope.trim();
  });

  var extraScopePlugin = function extraScopePlugin(context, content, selectors, parents, line, column, length, type) {
    if (context !== -1) {
      return;
    }

    var selector = selectors[0];
    selectors[0] = scopes[0] + " " + selector;

    for (var i = 1; i < scopes.length; i++) {
      selectors.push(scopes[i] + " " + selector);
    }
  };

  return extraScopePlugin;
}

export default createExtraScopePlugin;
